import { call,  put, } from 'redux-saga/effects';
import {SET_ERROR_MSG, SET_USER, CHANGE_LOADING, CLEAR_LOADING_ERROR_IF_EXISTS} from '@actions/actionTypes';
import { isRequest, isSetData } from "../../utils/CommonUtils";


export const safe = (handler = null, saga, ...args) => function* (action) {
    try {
        yield call(saga, ...args, action)
    } catch (err) {
        let  errMsg =  navigator.onLine ? err : "offline"
        console.error('error handling', err)
        yield call(handler, args, errMsg, action);
    }
}

export function* onError (args, err, action) {
    console.log('error', {args, err, action})
    err = err.toString();
    if (err == '401' ||err == '403') {
        alert(err)
        yield put({type: SET_USER, user: null});
    }

    let requestType = isRequest(action.type);

    yield put({type: SET_ERROR_MSG, data: {type: 'error', messages: `${err}`, actionType: action.type + '_ERROR', isOpenedByPopup: action.isOpenedByPopup}})

    if (requestType) {
        if (action.data && action.data.id) {
            yield put({type: CHANGE_LOADING, loading:{[requestType + action.data.id]: false}});
        } else {
            yield put({type: CHANGE_LOADING, loading:{[requestType]: false}});
        }
    }

    let setType = isSetData(action.type);

    if (setType) {
        if (action.data && action.data.id) {
            yield put({type: CHANGE_LOADING, loading:{[setType + action.data.id]: false}});
        } else {
            yield put({type: CHANGE_LOADING, loading:{[setType]: false}});
        }
    }
}